<div mat-dialog-title class="m-0">
    คำขอการเข้าถึงรายงานผล
    <div style="float: right; margin-top: -5px;">

        <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()"
            style="float: right; margin-top: -6px;">
            <img src="../../../../assets/close-white.png" style="width: 12px;">
        </button>
    </div>
</div>


<mat-dialog-content *ngIf="allPermission" id="modalSelectReport" class="mat-typography px-3">
    <div *ngIf="allPermission.length > 0" class="container pb-5 pt-3 wrapper-container">
        <div *ngFor="let item of allPermission" class="row d-flex justify-content-center">
            <div class="col-9">
                <p class="text-left text-permission">ยินยอมให้คุณ {{ item.USERNAME }} เข้าถึงรายงานผลของคุณ</p>
            </div>
            <div class="col-3 my-auto">
                <div class="d-flex justify-content-center">
                    <mat-slide-toggle [(ngModel)]="item.permission" (ngModelChange)="accept(item.permission, item)">
                        {{ item.permission ? 'ยอมรับ' : 'ไม่ยอมรับ' }}
                    </mat-slide-toggle>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="allPermission.length === 0" class="wrapper-container d-flex">
        <div class="m-auto">
            <h3 class="text-center text-secondary">ยังไม่มีคำขอ</h3>
        </div>
    </div>
</mat-dialog-content>